/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pool_Quick_RunInputs */

const bn_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দ্রুত রান`)
};

const de_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schneller Lauf`)
};

const el_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Γρήγορη εκτέλεση`)
};

const en_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick Run`)
};

const es_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejecución rápida`)
};

const fr_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partie rapide`)
};

const hi_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तेज़ भागना`)
};

const hu_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyors futás`)
};

const id_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lari Cepat`)
};

const it_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corsa veloce`)
};

const ja_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クイックラン`)
};

const ko_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빠른 실행`)
};

const nl_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snel rennen`)
};

const pl_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szybki bieg`)
};

const pt_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Execução rápida`)
};

const ru_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Быстрый бег`)
};

const sv_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snabbkörning`)
};

const tr_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hızlı Çalıştır`)
};

const uk_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Швидкий біг`)
};

const vi_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chạy nhanh`)
};

const zh_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速奔跑`)
};

const zh_hant_pool_quick_run = /** @type {(inputs: Pool_Quick_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速奔跑`)
};

/**
* | output |
* | --- |
* | "Quick Run" |
*
* @param {Pool_Quick_RunInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const pool_quick_run = /** @type {((inputs?: Pool_Quick_RunInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pool_Quick_RunInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_pool_quick_run(inputs)
	if (locale === "de") return de_pool_quick_run(inputs)
	if (locale === "el") return el_pool_quick_run(inputs)
	if (locale === "en") return en_pool_quick_run(inputs)
	if (locale === "es") return es_pool_quick_run(inputs)
	if (locale === "fr") return fr_pool_quick_run(inputs)
	if (locale === "hi") return hi_pool_quick_run(inputs)
	if (locale === "hu") return hu_pool_quick_run(inputs)
	if (locale === "id") return id_pool_quick_run(inputs)
	if (locale === "it") return it_pool_quick_run(inputs)
	if (locale === "ja") return ja_pool_quick_run(inputs)
	if (locale === "ko") return ko_pool_quick_run(inputs)
	if (locale === "nl") return nl_pool_quick_run(inputs)
	if (locale === "pl") return pl_pool_quick_run(inputs)
	if (locale === "pt") return pt_pool_quick_run(inputs)
	if (locale === "ru") return ru_pool_quick_run(inputs)
	if (locale === "sv") return sv_pool_quick_run(inputs)
	if (locale === "tr") return tr_pool_quick_run(inputs)
	if (locale === "uk") return uk_pool_quick_run(inputs)
	if (locale === "vi") return vi_pool_quick_run(inputs)
	if (locale === "zh") return zh_pool_quick_run(inputs)
	return zh_hant_pool_quick_run(inputs)
});